<script>
import CasesCommonHeadMobile from "@/components/mobile/案例/CasesCommonHeadMobile.vue";
import NextCaseButtonMobile from "@/components/mobile/案例/NextCaseButtonMobile.vue";

export default {
  name: "MobileMidea",
  components: {NextCaseButtonMobile, CasesCommonHeadMobile}
}
</script>

<template>
  <div class="MobileMidea">
    <CasesCommonHeadMobile :use-pic="true" :picurl="require('@/assets/picture/案例/Midea/移动端Banner.png')" :arrow-url="require('@/assets/anime/案例首页线条-蓝绿色.mp4')">
      <template #headerTitle>IMMPRO II 下一代集中控制平台</template>
      <template #headerSlogan>交互设计｜界面设计｜3D建筑模型</template>
      <template #title1>成果</template>
      <template #content1>IMMPRO II 是基于本地集控系统，用于美的多联机系列产品的集中控制，打造了行业领先的工业数字化管理体系并实现系统信息化、数据可视化、能源管理智能化。</template>
      <template #title2>背景</template>
      <template #content2>下一代集中控制平台包含Win, Andriod, IOS OS，彩屏硬件端等。希望在实现数字化控制的同时，降低操作人员的学习成本。</template>
    </CasesCommonHeadMobile>
    <div class="MideaCustom">
      <div class="Container1">
        <div class="Pic Picture1"></div>
        <div class="Pic Picture2"></div>
        <div class="Pic Picture3"></div>
      </div>
      <div class="Container2">
        <div class="Content">
          <div class="Title3">半3D视图<br>随时随地尽在掌控</div>
          <div class="Text3">设备查看更直观，支持楼层透明度调节，三维建筑比例大小调节。多用户多客户端进行管理，可管理5376台室外机。</div>
        </div>
        <div class="Pic4Box">
          <div class="Pic Picture4"></div>
          <div class="PicDesc1">设备控制，可同时管理5000+台设备</div>
        </div>
        <div class="Pic Picture5"></div>
      </div>
      <div class="Container3">
        <div class="Content">
          <div class="Title4">行业领先的<br>数字化管理平台</div>
          <div class="TextBox">
            <div class="Text4">在智能化运行，展示全面的数据视图，强化数据安全等功能上体现了美的IMMPRO II和同类产品的差异性。</div>
            <div class="Desc">官网域名/APP下载名称：immpro.midea.com</div>
          </div>
        </div>
        <div class="Picture6"></div>
      </div>
      <div class="NextContainer">
        <router-link to="/mobileCase/case004"><NextCaseButtonMobile></NextCaseButtonMobile></router-link>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/global.scss" as global;

@mixin flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
@mixin picbox{
  border-radius: 12px;
  background: {
    repeat: no-repeat;
    size: cover;
    position: center;
  };
}
@mixin margin{
  margin-top: calc(32vw / 3.93);
  margin-bottom: calc(32vw / 3.93);
}
@mixin titleColor{
  color: #2F5DC2;
}

.MideaCustom {
  width: 100%;
  height: auto;
  padding-left: 4%;
  padding-right: 4%;
  .Container1 {
    width: 100%;
    height: calc(560vw / 3.93);
    @include flex;
    @include margin;
    .Pic {
      @include picbox;
      width: 100%;
      height: calc(176vw / 3.93);
    }
    .Picture1 {
      background-image: url("@/assets/picture/案例/Midea/移动端Midea01.png");
    }
    .Picture2 {
      background-image: url("@/assets/picture/案例/Midea/移动端Midea02.png");
    }
    .Picture3 {
      background-image: url("@/assets/picture/案例/Midea/移动端Midea03.png");
    }
  }
  .Container2 {
    width: 100%;
    min-height: calc(644vw / 3.93);
    @include flex;
    @include margin;
    .Pic {
      @include picbox;
      width: 100%;
      height: calc(233vw / 3.93);
    }
    .Content {
      width: 100%;
      min-height: calc(64vw / 3.93);
      @include flex;
      flex-direction: row;
      .Title3 {
        width: 40%;
        height: 100%;
        overflow-y: auto;
        @include global.h4-vw-m;
        @include titleColor;
      }
      .Text3 {
        width: 50%;
        height: 100%;
        overflow-y: auto;
        @include global.h5-vw-m;
      }
    }
    .Pic4Box {
      width: 100%;
      height: calc(267vw / 3.93);
      @include flex;
      .Picture4 {
        background-image: url("@/assets/picture/案例/Midea/移动端Midea04.png");
      }
      .PicDesc1 {
        @include global.h4-vw-m;
        @include titleColor;
        font-weight: 300;
      }
    }
    .Picture5 {
      background-image: url("@/assets/picture/案例/Midea/移动端Midea05.png");
    }
  }
  .Container3 {
    @include margin;
    width: 100%;
    min-height: calc(370vw / 3.93);
    @include flex;
    .Content {
      @include flex;
      flex-direction: row;
      .Title4 {
        width: 40%;
        height: 100%;
        @include global.h4-vw-m;
        @include titleColor;
      }
      .TextBox {
        width: 50%;
        height: 100%;
        @include flex;
        .Text4 {
          width: 100%;
          height: 100%;
          @include global.content-vw-m;
          font-weight: 300;
        }
        .Desc {
          width: 100%;
          height: 100%;
          @include global.content-vw-m;
          @include titleColor;
          font-weight: 300;
        }
      }
    }
    .Picture6 {
      width: 100%;
      height: calc(233vw / 3.93);
      @include picbox;
      background-image: url("@/assets/picture/案例/Midea/移动端Midea06.png");
    }
  }
  .NextContainer {
    width: 100%;
    height: calc(44vw / 3.93);
    padding-left: 17%;
    padding-right: 17%;
    margin-top: calc(64vw / 3.93);
    margin-bottom: calc(64vw / 3.93);
  }
}

</style>